import React from 'react';

import { BarChart3, ListChecks, AlertTriangle } from 'lucide-react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

import { ListeTab, StatsTab, SignalementsTab } from './CommunityplaceTabs';

export default function SuperAdminCommunityplacePanel() {
  return (
    <div className="space-y-6" data-testid="super-admin-communityplace-panel">
      <header>
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          🏛️ Communityplace — Gestion Super Admin
        </h2>
        <p className="text-sm text-gray-600 mt-1">
          Vue globale toutes organisations. Édition, modération, signalements, KPIs.
        </p>
      </header>

      <Tabs defaultValue="liste" className="w-full">
        <TabsList className="grid grid-cols-3 max-w-2xl">
          <TabsTrigger value="liste" data-testid="sa-cp-tab-liste">
            <ListChecks className="h-4 w-4 mr-2" /> Vue d&apos;ensemble
          </TabsTrigger>
          <TabsTrigger value="stats" data-testid="sa-cp-tab-stats">
            <BarChart3 className="h-4 w-4 mr-2" /> Statistiques
          </TabsTrigger>
          <TabsTrigger value="signalements" data-testid="sa-cp-tab-signalements">
            <AlertTriangle className="h-4 w-4 mr-2" /> Signalements
          </TabsTrigger>
        </TabsList>

        <TabsContent value="liste" className="mt-6">
          <ListeTab />
        </TabsContent>
        <TabsContent value="stats" className="mt-6">
          <StatsTab />
        </TabsContent>
        <TabsContent value="signalements" className="mt-6">
          <SignalementsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
